export enum SessionPolicyKey {
    AllowConcurrentBrowserSessions = 'AllowConcurrentBrowserSessions',
    IdleTimeoutDuration = 'IdleTimeoutDuration',
}

export enum TimeUnits {
    HOURS = 'hours',
    MINUTES = 'minutes',
}
